/**
 * Banner Model
 */

define(function(require, exports, module) {
    'use strict';

    var user = require('user');
    var config = require('config');
    var url = require('util/url.util');
    var HeaderModel = require('portlets/header/header.model');

    module.exports = HeaderModel.extend({

        preparePredefinedPages: function() {
            var account = getVal('accountPage');
            var lang = getVal('languagePage');
            var registration = getVal('registrationURL');
            var balance = getVal('balancePage');

            var showBalance = url.getLocationParameterByName('showHeaderOnlyOnMobile') !== '1';

            function getVal(propName) {
                var val = config.get(propName);
                return val ? val.trim() : '';
            }

            return {
                availabilityPredefinedPages: {
                    account: Boolean(account),
                    language: Boolean(lang),
                    registration: Boolean(registration),
                    balance: Boolean(user.get('showLowBalancePopup') || balance) && showBalance
                },
                predefinedPages: {
                    account: account,
                    language: lang,
                    registration: registration,
                    balance: balance
                }
            };
        }
    });
});
